<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent max-width="1600px">
      <v-card v-if="room !== undefined">
        <v-card-title>
          <v-layout wrap>
            <v-flex xs12>
              <h3 style="margin-bottom: 30px;text-align: left">Kognitiv Raten verwalten für {{room.name}} ({{room.externalId}})</h3>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-form ref="manageRateForm" v-model="valid" lazy-validation style="width: 100%;">
            <v-layout wrap>
              <v-flex xs12>
                <v-data-table
                  :headers="headers"
                  :items="room.kognitivRatePlans"
                  hide-default-footer item-key="ratePlan">
                  <template v-slot:item="props">
                    <tr>
                      <td>
                        <v-toolbar flat color="teal lighten-5" style="min-width: 300px;">
                          <v-toolbar-title>{{ props.item.ratePlan }}</v-toolbar-title>
                          <v-spacer/>
                          <v-toolbar-items>
                            <v-text-field
                              style="max-width: 70px;margin-top: 20px; height: 40px"
                              color="primary"
                              label="Position"
                              type="number"
                              v-model="props.item.position"
                              required/>
                          </v-toolbar-items>
                        </v-toolbar>
                        <v-text-field
                          v-model="props.item.name"
                          label="Name"
                          required
                          :rules="rules"
                        />
                      </td>
                      <td>
                        <occupancy-payment-rule :rate-plan="props.item" :room="room"/>
                      </td>
                      <td>
                        <v-layout wrap justify-space-between pb-2 pt-2 class="text-sm-left" v-if="room.maxOccupancy > 1">
                          <v-flex xs12>
                            <v-layout wrap>
                              <v-flex xs12>
                                <h3 style="margin-bottom: 10px;">Regelung für die Zusatzgäste</h3>
                              </v-flex>
                              <v-flex xs12 sm5 md3>
                                <v-select v-model="props.item.additionalGuestPaymentMode"
                                          :items="paymentModes"
                                          item-text="label"
                                          item-value="value"
                                          label="Berechnungsmodus"/>
                              </v-flex>
                              <v-flex xs12 offset-xs0 sm5 offset-sm2 md4 offset-md2>
                                <v-text-field
                                  v-model="props.item.additionalGuestPrice"
                                  :label="getChildrenValueLabel(props.item.additionalGuestPaymentMode)"
                                  mask="###"
                                  persistent-hint
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 mt-3 class="children-rules-container">
                            <h3 style="margin-bottom: 10px;">{{ $t('hotel.kognitiv.childrenRules') }}</h3>
                            <v-layout wrap>
                              <v-flex xs12 sm12 md10 lg6>
                                <v-select v-model="props.item.childrenPaymentMode"
                                          :items="paymentModes"
                                          item-text="label"
                                          item-value="value"
                                          label="Berechnungsmodus"/>
                              </v-flex>
                            </v-layout>
                            <div v-if="props.item.childrenRules.length === 0">
                              {{ $t('hotel.kognitiv.childRulesNotDefinedYet') }}
                            </div>
                            <v-list dense v-else>
                              <div v-for="(rule, index) in props.item.childrenRules" :key="index">
                                <div style="cursor: pointer;">
                                  <v-list-item style="min-height: 30px;">
                                    <v-list-item-content>{{ $t('hotel.kognitiv.childUntil') }}</v-list-item-content>
                                    <v-list-item-content class="text-sm-right">
                                      <v-edit-dialog
                                        :return-value.sync="rule.age"
                                        lazy>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <div style="display:inline-block;" v-on="on">{{ rule.age }}</div>
                                          </template>
                                          <span>Bearbeiten</span>
                                        </v-tooltip>
                                        <v-text-field
                                          slot="input"
                                          v-model="rule.age"
                                          :rules="rules"
                                          label="Alter"
                                          single-line
                                          mask="##"
                                        />
                                      </v-edit-dialog>
                                    </v-list-item-content>
                                    <v-list-item-action style="margin-top: 0;margin-bottom: 0;cursor: default;">
                                      <v-btn style="margin-top: -25px;opacity: 0;" disabled
                                             @click="removeChildrenRule(props.item.childrenRules, index)">
                                      </v-btn>
                                    </v-list-item-action>
                                  </v-list-item>
                                  <v-list-item style="min-height: 30px;">
                                    <v-list-item-content>
                                    <span v-if="props.item.childrenPaymentMode === 'EURO'">
                                      {{ $t('hotel.kognitiv.additionalGuestPrice') }}
                                    </span>
                                      <span v-else>Prozent</span>
                                    </v-list-item-content>
                                    <v-list-item-content class="text-sm-right">
                                      <v-edit-dialog :return-value.sync="rule.price" lazy>
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <div style="display:inline-block;" v-on="on">
                                              {{ rule.price }}
                                              <span v-if="props.item.childrenPaymentMode === 'EURO'"> €</span>
                                              <span v-else> %</span>
                                            </div>
                                          </template>
                                          <span>Bearbeiten</span>
                                        </v-tooltip>
                                        <v-text-field
                                          slot="input"
                                          v-model="rule.price"
                                          :rules="rules"
                                          :label="getChildrenValueLabel(props.item.childrenPaymentMode)"
                                          single-line
                                          mask="###"
                                        />
                                      </v-edit-dialog>
                                    </v-list-item-content>
                                    <v-list-item-action style="margin-top: 0;margin-bottom: 0;">
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <v-btn icon ripple style="margin-top: -33px;" v-on="on"
                                                 @click="removeChildrenRule(props.item.childrenRules, index)">
                                            <v-icon color="red">delete</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Kinderregelung löschen</span>
                                      </v-tooltip>
                                    </v-list-item-action>
                                  </v-list-item>
                                </div>
                                <v-divider/>
                              </div>
                            </v-list>
                          </v-flex>
                          <v-flex xs12>
                            <add-children-rule :rate-plan="props.item"/>
                          </v-flex>
                        </v-layout>
                      </td>
                      <td>
                        <v-btn outlined color="primary"
                               @click="openBasePriceContainer(props)">
                          Grundpreis anzeigen
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="closeDialog()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="price.dialog" scrollable persistent max-width="1200px">
      <v-card v-if="price.dialog">
        <v-card-text>
          <base-price-rule :rate-plan="price.selected" :hotel-d-t-o="hotelDTO" :room="room"/>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="closePriceDialog()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import AddChildrenRule from './templates/AddChildrenRule';
  import OccupancyPaymentRule from './templates/OccupancyPaymentRule';
  import BasePriceRule from './templates/BasePriceRule';

  export default {
    name: 'ManageKognitivRatePlans',
    components: {
      AddChildrenRule, OccupancyPaymentRule, BasePriceRule,
    },
    data() {
      return {
        valid: undefined,
        dialog: false,
        hotelDTO: undefined,
        room: undefined,
        headers: [
          { text: this.$i18n.t('hotel.kognitiv.rateplan'), align: 'left', sortable: false },
          { text: this.$i18n.t('hotel.settings.occupancy'), align: 'left', sortable: false },
          { text: this.$i18n.t('hotel.settings.additional'), align: 'left', sortable: false },
          { text: this.$i18n.t('hotel.kognitiv.basePrice'), align: 'left', sortable: false },
        ],
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
        paymentModes: [
          { value: 'PERCENT', label: 'Prozent' },
          { value: 'EURO', label: 'Euro' }
        ],
        price: {
          dialog: false,
          selected: undefined
        }
      };
    },
    mounted() {
      this.globalEvents.$on('openManageKognitivRatePlans', (room, hotelDTO) => {
        this.room = room;
        this.hotelDTO = hotelDTO;
        this.dialog = true;
      });
    },
    methods: {
      removeChildrenRule(childrenRules, index) {
        this.globalEvents.$emit('kognitivHotelEditLeave', true);
        childrenRules.splice(index, 1);
      },
      openBasePriceContainer(props) {
        this.price.selected = props.item;
        this.price.dialog = true;
      },
      closePriceDialog() {
        this.price.dialog = false;
        this.price.selected = undefined;
      },
      closeDialog() {
        if (this.$refs.manageRateForm.validate()) {
          this.dialog = false;
        }
      },
      getChildrenValueLabel(mode) {
        return mode === 'EURO' ? 'Preis' : 'Prozent';
      }
    }
  }
</script>

<style lang="scss">
  .children-rules-container {
    .v-list {
      background: transparent !important;
      .v-list__tile {
        height: 20px !important;
        .v-list__tile__content {
          height: 20px !important;
        }
      }
    }
    .v-menu__activator {
      float: right;
    }
  }
</style>
